import VisitedAccountsMenu from './VisitedAccountsMenu';

export default VisitedAccountsMenu;
